/**
 * CP-457: mapeo de una fila de `GET /collectors/{id}/TaskMonitor` (adminapi) a UploadTask.
 * Vive en lib (sin dependencias) para poder testearlo con `node --test`.
 */
export interface UploadTask {
  pk:                string;   // id del collector (adminapi lo devuelve sin el prefijo "collector#")
  sk:                string;
  taskType:          string;
  createdAt:         string | null;
  updatedAt:         string | null;
  downloadFile:      string | null;   // nombre original del archivo que subió el usuario (fileName)
  /** CP-457: CSV de resultado que genera AsyncTasks (resultFileName); null si adminapi no lo manda o la tarea no terminó. */
  resultFile:        string | null;
  status:            string;
  statusDescription: string;
}

export function mapUploadTask(t: any, collectorId: string): UploadTask {
  return {
    pk: String(t.pk ?? collectorId), sk: String(t.sk ?? ""), taskType: t.taskType ?? "",
    createdAt: t.creationDateTime ?? null, updatedAt: t.lastUpdated ?? null,
    downloadFile: t.fileName ?? null,
    resultFile: t.resultFileName || null,
    status: String(t.status ?? ""), statusDescription: t.statusDescription ?? "",
  };
}
